import * as types from '../actions/actionTypes'


const CompaniesReducer = (state = {
    currentCompany: {},
    connectedCompanies: [],
}, action) => {

    switch(action.type) {
      case types.GET_COMPANIES_INFO_SUCCESS: 
      state = {
        ...state,
        connectedCompanies: action.payload,
      };
      break;
      case types.SET_CURRENT_COMPANY: 
      const connectedCompanies = state.connectedCompanies
      const result = connectedCompanies.filter(companyObject => companyObject.companyID == action.payload);
      state = {
        ...state,
        currentCompany: result[0],
      };
      break;
      case types.SET_CURRENT_COMPANY_TO_EMPTY: 
      state = {
        ...state,
        currentCompany: {},
      };
      break;

      case types.UPDATE_CURRENT_COMPANY: 
      const updatedCompany = action.payload

      state = {
        ...state,
        currentCompany: updatedCompany,
      };
      break;

      case types.UPDATE_CURRENT_COMPANY_SHOULD_USE_BONUS_LEVELS: 

      const newShouldUseBonusLevelCompany ={
        ...state.currentCompany,
        useBonusLevels: action.payload,
        resetBonusLevelsQuarterly: action.payloadTwo
      }

      state = {
        ...state,
        currentCompany: newShouldUseBonusLevelCompany,
      };
      break;

      default:
      break;    
    }

    return state;
};


export default CompaniesReducer;


// WEBPACK FOOTER //
// ./src/reducers/companiesReducer.js